import type { BimContractResultPlanData } from 'gql/graphql';
import { BimActKc2OtherStatusEnum, BimChapterEnum, SectionEnum } from 'gql/graphql';
import type { IListItem } from 'types/Contract';

export const totalsByConstructionTypeKey = 'TOTALS_BY_CONSTRUCTION_TYPE';

export const bimWorkOrderChaptersAndSectionsListItems: IListItem<string>[] = [
    { id: BimChapterEnum.Chapter1, label: 'Глава 1' },
    { id: BimChapterEnum.Chapter2, label: 'Глава 2' },
    { id: BimChapterEnum.Chapter3, label: 'Глава 3' },
    { id: BimChapterEnum.Chapter4, label: 'Глава 4' },
    { id: BimChapterEnum.Chapter5, label: 'Глава 5' },
    { id: BimChapterEnum.Chapter6, label: 'Глава 6' },
    { id: BimChapterEnum.Chapter7, label: 'Глава 7' },
    { id: BimChapterEnum.Chapter8, label: 'Глава 8' },
    { id: BimChapterEnum.Chapter9, label: 'Глава 9' },
    { id: BimChapterEnum.Chapter12, label: 'Глава 12' },
    { id: BimChapterEnum.Others, label: 'Прочие' },
    { id: totalsByConstructionTypeKey, label: 'Итоги по виду строительства' },
    { id: SectionEnum.WorkOrderTotals, label: 'Итоги НЗ' },
];

export const getActualBimWorkOrderChaptersAndSectionsListItems = (
    isFrameContract: boolean,
    isWorkOrderChange: boolean,
) => {
    if (isWorkOrderChange) {
        return bimWorkOrderChaptersAndSectionsListItems.map((item, idx, source) => {
            if (idx === source.length - 1) {
                return { ...item, label: 'Итого по Изм.' };
            }

            return item;
        });
    }

    if (isFrameContract) {
        return bimWorkOrderChaptersAndSectionsListItems;
    }

    return bimWorkOrderChaptersAndSectionsListItems.map((item, idx, source) => {
        if (idx === source.length - 1) {
            return { ...item, label: 'Итого по Расчету' };
        }

        return item;
    });
};

export const bimWorkOrderTotalsChapterLabel = {
    [BimChapterEnum.Chapter1]: 'Главы 1',
    [BimChapterEnum.Chapter2]: 'Главы 2',
    [BimChapterEnum.Chapter3]: 'Главы 3',
    [BimChapterEnum.Chapter4]: 'Главы 4',
    [BimChapterEnum.Chapter5]: 'Главы 5',
    [BimChapterEnum.Chapter6]: 'Главы 6',
    [BimChapterEnum.Chapter7]: 'Главы 7',
    [BimChapterEnum.Chapter8]: 'Главы 8',
    [BimChapterEnum.Chapter9]: 'Главы 9',
    [BimChapterEnum.Chapter12]: 'Главы 12',
};

export const bimWorkOrderChapterLabel = {
    [BimChapterEnum.Chapter1]: 'Глава 1',
    [BimChapterEnum.Chapter2]: 'Глава 2',
    [BimChapterEnum.Chapter3]: 'Глава 3',
    [BimChapterEnum.Chapter4]: 'Глава 4',
    [BimChapterEnum.Chapter5]: 'Глава 5',
    [BimChapterEnum.Chapter6]: 'Глава 6',
    [BimChapterEnum.Chapter7]: 'Глава 7',
    [BimChapterEnum.Chapter8]: 'Глава 8',
    [BimChapterEnum.Chapter9]: 'Глава 9',
    [BimChapterEnum.Chapter12]: 'Глава 12',
    [BimChapterEnum.Others]: 'Прочие',
};

export enum BimWorkOrderRowTypeEnum {
    RegularString = 'RegularString',
    TotalsString = 'TotalsString',
}

export const getDetailsInPriceTableRequestId = (useInPrices: boolean): string =>
    `bimWorkOrderTotalsRow${useInPrices ? 'UseInPrices' : ''}`;

export const isBimChapter = (value: string | undefined): boolean =>
    !!(value && Object.values(BimChapterEnum).includes(value as BimChapterEnum) && value !== BimChapterEnum.Others);
export const isOtherBimChapter = (value: string | undefined): boolean => value === BimChapterEnum.Others;
export const isTotalsBimChapter = (value: string | undefined): boolean =>
    value === SectionEnum.WorkOrderTotals || value === totalsByConstructionTypeKey;

export enum BimWorkOrderStructureOperation {
    CreateObject = 'CreateObject',
    DeleteSubObject = 'DeleteSubObject',
    DeleteObject = 'DeleteObject',
}

export enum GroupNameKey {
    AddOtherTable = 'AddOtherTable',
}

type GroupNameType = {
    [key in SectionEnum]: string;
} & {
    [key in GroupNameKey]: {
        [innerKey in SectionEnum]: string;
    };
};
export const OTHER_TABLE_GROUP_NAME: GroupNameType = {
    [SectionEnum.CustomerLimits]: 'Лимиты Заказчика',
    [SectionEnum.Others]: 'Прочие затраты 9 Главы',
    [SectionEnum.WorkOrderTotals]: '',
    [SectionEnum.LimitedCost]: '',
    [GroupNameKey.AddOtherTable]: {
        [SectionEnum.CustomerLimits]: 'Лимиты Заказчика',
        [SectionEnum.Others]: 'Глава 9',
        [SectionEnum.WorkOrderTotals]: '',
        [SectionEnum.LimitedCost]: '',
    },
};

export const OTHER_TABLE_EDIT_NAME = {
    [SectionEnum.CustomerLimits]: 'Лимиты Заказчика',
    [SectionEnum.Others]: 'Глава 9',
    [SectionEnum.WorkOrderTotals]: 'Итоги НЗ',
};

export const OTHER_TABLE_SECTION_NAME = {
    [SectionEnum.CustomerLimits]: 'Лимиты Заказчика',
    [SectionEnum.Others]: 'Прочие',
    [SectionEnum.WorkOrderTotals]: 'Итоги НЗ',
};

export enum BimWorkOrderRowDetailsType {
    Details = 'Details',
    Revision = 'Revision',
    Update = 'Update',
    ActsKc2 = 'ActsKc2',
    Analytics = 'Analytics',
}

export const bimActKc2OtherStatusesTitles = {
    [BimActKc2OtherStatusEnum.InProgress]: 'В работе',
    [BimActKc2OtherStatusEnum.OnCheck]: 'На проверке',
    [BimActKc2OtherStatusEnum.Accepted]: 'Согласован',
};

export interface IBimActKc2OtherStatusesListItem {
    id: BimActKc2OtherStatusEnum;
    label: string;
}

export const bimActKc2OtherStatusesListItems: IBimActKc2OtherStatusesListItem[] = [
    {
        id: BimActKc2OtherStatusEnum.InProgress,
        label: bimActKc2OtherStatusesTitles[BimActKc2OtherStatusEnum.InProgress],
    },
    {
        id: BimActKc2OtherStatusEnum.OnCheck,
        label: bimActKc2OtherStatusesTitles[BimActKc2OtherStatusEnum.OnCheck],
    },
    {
        id: BimActKc2OtherStatusEnum.Accepted,
        label: bimActKc2OtherStatusesTitles[BimActKc2OtherStatusEnum.Accepted],
    },
];

export const getActsKc2OtherCostPlanKey = (actId: number) => `actsKc2OtherCostPlan${actId}`;

export const getActsKc2OtherCostAcceptedKey = (actId: number) => `actsKc2OtherCostAccepted${actId}`;

export const getActsKc2OtherCostCommentKey = (actId: number) => `actsKc2OtherCostComment${actId}`;

export interface IBimContractResultPlanDataItem extends BimContractResultPlanData {
    id: string;
}
